export default "__VITE_ASSET__Yp7lNbZb__"